import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store, { key } from './store';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import * as ElIcons from '@element-plus/icons-vue';
import dialogDrag from '@/utils/dialogDrag'; //引入封装的拖拽方法
import VueCookies from 'vue-cookies';


const app = createApp(App);

app.config.globalProperties.cookies = VueCookies;

for (const name in ElIcons) {
  app.component(name, (ElIcons as any)[name]);
}

app
  .use(store, key)
  .use(router)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .use(dialogDrag)
  .mount('#app');
